import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
dayjs.extend(utc);
dayjs.extend(timezone);

const RowPerDayChart = ({ rowPerDay }) => {
  const theme = useTheme();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (rowPerDay) {
      const dayLabels = rowPerDay.map((rowPerDayObj) =>
        dayjs(rowPerDayObj["date"]).format("ddd")
      );
      const dailyRowDistance = rowPerDay.map(
        (rowPerDayObj) => rowPerDayObj.row_distance
      );

      const data = {
        labels: dayLabels,
        datasets: [
          {
            data: dailyRowDistance,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
            fill: false,
            tension: 0.1,
          },
        ],
      };

      setChartData(data);
    }
  }, [rowPerDay, theme.palette.primary.main]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
        labels: {
          color: theme.palette.text.primary,
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `Row Distance: ${context.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: theme.palette.text.primary,
          font: {
            size: 12,
          },
        },
        grid: {
          color: theme.palette.divider,
        },
      },
      y: {
        ticks: {
          color: theme.palette.text.primary,
          font: {
            size: 12,
          },
        },
        grid: {
          color: theme.palette.divider,
        },
      },
    },
  };

  return (
    <Box sx={{ width: "100%", height: "144px", mt: 2 }}>
      {chartData ? (
        <Line options={options} data={chartData} />
      ) : (
        <Typography>No data available</Typography>
      )}
    </Box>
  );
};

export default RowPerDayChart;
